import { hasMeaningfulValue, isPlainObject } from '../../../utils';

const GPU_MEANINGFUL_KEYS = [
  'vendor',
  'device',
  'vendorID',
  'vendorId',
  'deviceID',
  'deviceId',
  'number',
  'name',
  'code',
  'deviceType',
] as const;

/** 表单 gpu 块是否已配置（非空对象且至少有一个有效字段） */
export function hasConfiguredGpu(raw: unknown): boolean {
  if (!isPlainObject(raw)) return false;
  if (Object.keys(raw).length === 0) return false;
  return GPU_MEANINGFUL_KEYS.some((key) => hasMeaningfulValue(raw[key]));
}
